import {
  ElementNode,
  SerializedElementNode,
  LexicalNode,
  NodeKey,
  $applyNodeReplacement,
  EditorConfig,
  DOMConversionMap,
  Spread,

  $isTextNode,
} from 'lexical';

export type SerializedWhatsAppCodeBlockNode = Spread<
  {
    type: 'whatsapp-code-block';
  },
  SerializedElementNode
>;

/**
 * WhatsApp Code Block Node
 * Uses triple backticks (```code```) for multi-line code blocks
 */
export class WhatsAppCodeBlockNode extends ElementNode {
  static getType(): string {
    return 'whatsapp-code-block';
  }

  static clone(node: WhatsAppCodeBlockNode): WhatsAppCodeBlockNode {
    return new WhatsAppCodeBlockNode(node.__key);
  }

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(key?: NodeKey) {
    super(key);
  }

  createDOM(config: EditorConfig): HTMLElement {
    const element = document.createElement('code');
    element.className = config.theme.whatsappCodeBlock || '';
    
    // Ensure block display for the code element to behave like a block
    element.style.display = 'block';
    
    return element;
  }

  updateDOM(): boolean {
    return false;
  }

  static importDOM(): DOMConversionMap | null {
    return {
      pre: () => ({
        conversion: () => ({ node: null }),
        priority: 1,
      }),
    };
  }

  static importJSON(serializedNode: SerializedWhatsAppCodeBlockNode): WhatsAppCodeBlockNode {
    const node = $createWhatsAppCodeBlockNode();
    return node;
  }

  exportJSON(): SerializedWhatsAppCodeBlockNode {
    return {
      ...super.exportJSON(),
      type: 'whatsapp-code-block',
    };
  }

  // Get text content for markdown export
  getTextContent(): string {
    const children = this.getChildren();
    return children.map(child => {
      if ($isTextNode(child)) {
        return child.getTextContent();
      }
      return '';
    }).join('');
  }

  exportMarkdown(): string {
    const content = this.getTextContent();
    return `\`\`\`\n${content}\n\`\`\``;
  }



  isInline(): boolean {
    return false;
  }
}

export function $createWhatsAppCodeBlockNode(): WhatsAppCodeBlockNode {
  return $applyNodeReplacement(new WhatsAppCodeBlockNode());
}

export function $isWhatsAppCodeBlockNode(
  node: LexicalNode | null | undefined
): node is WhatsAppCodeBlockNode {
  return node instanceof WhatsAppCodeBlockNode;
}
